// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-iframe-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.preview-iframe-wrapper .preview-iframe {
  width: 100%;
  height: 100%;
  background-color: white;
}
.preview-iframe-wrapper .editor-preview-loading {
  background-color: var(--color-bg);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.preview-iframe-wrapper .editor-preview-loading .loader {
  font-size: 48px;
  color: var(--dark-color-light);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/PreviewIFrame.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AACJ;AAEE;EACE,iCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,eAAA;EACA,8BAAA;AAAN","sourcesContent":[".preview-iframe-wrapper{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  .preview-iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n  }\r\n\r\n  .editor-preview-loading{\r\n    background-color: var(--color-bg);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n  \r\n    .loader{\r\n      font-size: 48px;\r\n      color: var(--dark-color-light);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
